const setSystemData = (
  state,
  {
    productVersion,
    agentStates,
    allAgentStates,
    completionStatuses,
    elementStates,
    interactionStates,
    interactionTypes,
    pendingStatuses,
    softPhoneSettings
  }
) => {
  state.productVersion = productVersion;
  state.agentStates = agentStates;
  state.allAgentStates = allAgentStates;
  state.completionStatuses = completionStatuses;
  state.elementStates = elementStates;
  state.interactionStates = interactionStates;
  state.interactionTypes = interactionTypes;
  state.pendingStatuses = pendingStatuses;
  state.softPhoneSettings = softPhoneSettings;
};

export default {
  setSystemData
};
